export function formatTelephone(telephone: string) {
  let newPhone = '';

  if (!telephone) {
    return '';
  }

  if (telephone.indexOf('+33') !== -1) {
    newPhone = telephone.replace('+33', '0');
    return newPhone;
  }
  if (telephone.indexOf('+32') !== -1) {
    newPhone = telephone.replace('+32', '0');
    return newPhone;
  }
  return telephone;
}
